
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Tile from '../../navigation/MobileNavigation/Tile';
import { PRODUCTS, PRODUCT_LINKS } from '../../../constants';

import styles from './PopularProducts.module.scss';

const PopularProducts = ({
  history,
  toggleNavigation,
  changeProduct,
  showLabel
}) => {
  const startAlignedSectionClass = classNames({
    [styles.sectionContent]: true,
    [styles.rowStart]: true
  });

  const navigate = useCallback(({ url, product: productUpdate }) => {
    toggleNavigation(false);

    const timer = setTimeout(() => {
      if (productUpdate) {
        changeProduct(productUpdate);
      }

      history.push(url);
    }, 270);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const updatedProducts = PRODUCT_LINKS.filter((
    ({ id }) => ![PRODUCTS.exchange, PRODUCTS.mbzero].includes(id)
  ));

  return (
    <div className={startAlignedSectionClass}>
      {updatedProducts.map(({
        id,
        name,
        urlName,
        url
      }) => {
        const isPredictions = id === PRODUCTS.predictions;
        const isLinkExternal = url.startsWith('http');
        return (
          <Tile
            key={id}
            product={id}
            name={name}
            iconName={urlName || PRODUCTS.exchange}
            url={url}
            onClick={!isPredictions ? navigate : undefined}
            dataHook={`mob-nav-${id}`}
            className=".gtm_cta"
            section={'popularProducts'}
            showLabel={showLabel}
            isExternalLink={isLinkExternal}
            openInNewTab={!(isPredictions && isLinkExternal)}
          />
        );
      })}
    </div>
  );
};

PopularProducts.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }),
  toggleNavigation: PropTypes.func.isRequired,
  changeProduct: PropTypes.func.isRequired,
  showLabel: PropTypes.bool.isRequired,
};

export default PopularProducts;
